import { useSearchCauses } from 'core/Api';
import { useNavigate } from 'react-router-dom';
import { CauseDetail, CauseStoreCard, Divider, SimpleGrid, Stack, Title } from 'ui';

const TrendingCauses = () => {
  const { data: causes } = useSearchCauses({
    queryOptions: { searches: { trending: { value: true } } },
  });
  const navigate = useNavigate();

  return (
    <Stack>
      <Title order={2}>Trending Causes</Title>
      <SimpleGrid cols={{ base: 1, sm: 2 }} verticalSpacing={0}>
        {causes?.map((cause) => {
          const website = cause?.links?.find((link) => link.type == 'website')?.url;

          return (
            <Stack key={cause.uuid} gap={0}>
              <CauseStoreCard
                direction="column"
                imgSrc={cause.logo?.url}
                title={cause.name}
                info={{
                  detail: <CauseDetail city={cause.city} state={cause.state} website={website} />,
                }}
                onClick={() => navigate(`${cause.uuid}`)}
              />
              <Divider size="sm" color="gray.0" mx="md" />
            </Stack>
          );
        })}
      </SimpleGrid>
    </Stack>
  );
};

export { TrendingCauses };
